import { useAppDispatch } from '@/shared/lib/redux'
import {
    openPostResultsModal as openPostResultsModalAction,
    openToggleCampaignModal as openToggleCampaignModalAction,
} from '../../model'
import { IMarketingCampaing } from '@/shared/api/marketing-campaigns'

export const useUpdateCampaignModal = () => {
    const dispatch = useAppDispatch()

    const openPostResultsModal = (campaign: IMarketingCampaing) => {
        dispatch(openPostResultsModalAction({
            data: campaign
        }))
    }

    const openToggleCampaignModal = (campaign: IMarketingCampaing, onToggle?: () => void) => {
        dispatch(openToggleCampaignModalAction({
            data: campaign,
            onToggle
        }))
    }
    
    return {
        openToggleCampaignModal,
        openPostResultsModal
    }
}